import { $translate } from '@/utils/i18n';
export default {
    'formUp': [
        {
            'prop': 'tenantCode',
            'label': $translate('lang.E3202103110001', { defaultText: '租户代码' })
        },
        {
            'prop': 'tenantName',
            'label': $translate('lang.E3202103110002', { defaultText: '租户名称' })
        },
        {
            'prop': 'maxIdentityAmount',
            'label': $translate('lang.E3202103120001', { defaultText: '总标识量' })
        },
        {
            'prop': 'maxLogAmount',
            'label': $translate('lang.E3202103120002', { defaultText: '总日志量' })
        },
        {
            'prop': 'maxTotalFileSize',
            'label': $translate('lang.E3202103120003', { defaultText: '文件存储(MB)' })
        },
        {
            'prop': 'maxDailyParsingAmount',
            'label': $translate('lang.E3202103120004', { defaultText: '日解析量' })
        },
        {
            'prop': 'maxDailyRegistingAmount',
            'label': $translate('lang.E3202103120005', { defaultText: '日注册量' })
        }
    ],
    'newQuota': {
        'colSpan': 12
    }
};